<template>
  <div>
      <VSGraph class="marginal" :video="{uuid: '*'}" v-if="clientView === 'viewsurf'"></VSGraph>
      <CompleteAnalytics class="marginal" :video="{uuid: '*'}" />
  </div>
</template>

<script>
import CompleteAnalytics from "@/components/analytics/CompleteAnalytics.vue";
import VSGraph from "@/components/analytics/VSGraph.vue";
import PriceAnalytics from "@/components/analytics/PriceAnalytics.vue";

import AnalyticsService from "@/services/analytics.service";
import AuthorizationKeyService from "@/services/authorizationKey.service";
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import { Chart } from "chart.js";
import 'chartjs-plugin-labels';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import VideoService from "@/services/video.service";
import UserService from "@/services/user.service";


var analyticsService = new AnalyticsService();
var authorizationKeyService = new AuthorizationKeyService();
var videoService = new VideoService();
var userService = new UserService();
export default {
  name: 'GlobalAnalyticsPage',
  components: {
    CompleteAnalytics,
    PriceAnalytics,
    FadeLoader,
    VSGraph
  },
  data: function() {
      return {

            clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,

            iframesrc: '',
            iframesrcComplete: '',
      }
  },
  computed: {
      dataMonth2() {
          return (Math.round(this.dataMonth / 10000) / 100) + ' TB';
      }
  },
  mounted() {
      // INIT URL IFRAME GLOBAL ANALYTICS
      var baseurl = this.$auth.getMyUser().analyticsUrl || "https://platforms3.joada.net";
      var nameDashboard = this.$auth.getMyUser().analyticsDashboard || "global-analytics" || "analytics";
      var analyticsAddr = `analytics${this.clientView}`
      this.iframesrc = `${baseurl}/${analyticsAddr}/d/${nameDashboard}/${nameDashboard}`
      this.iframesrcComplete = this.iframesrc;

  },
  methods:{
     
      //Show modal if wrong date 
      showModal2(ref) {
        this.$refs[ref].show();
      },
      hideModal2 (ref) {
        this.$refs[ref].hide();
      },
  }
}
</script>